/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2021-09-22 09:39:53
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    redirect: {
      name: 'index'
    },
    children: [
      {
        path: '/index',
        component: () => import('@/views/index.vue'),
        name: 'index',
        meta: {
          title: '首页'
        }
      },
      {
        path: '/list',
        component: () => import('@/views/list.vue'),
        name: 'list',
        meta: {
          title: '列表'
        }
      },
      {
        path: '/detail',
        component: () => import('@/views/detail.vue'),
        name: 'detail',
        meta: {
          title: '描述页'
        }
      },
      {
        path: '/myplan',
        component: () => import('@/views/myplan.vue'),
        name: 'myplan',
        meta: {
          title: '我的课表'
        }
      },
      {
        path: '/examination',
        name: 'examination',
        component: () => import('@/views/exam/examination.vue'),
        meta: {
          title: '在线考试入口'
        }
      },
      {
        path: '/questionBank',
        name: 'questionBank',
        component: () => import('@/views/questionBank/index.vue'),
        meta: {
          title: '考试题库'
        }
      },
      {
        path: '/exam',
        name: 'exam',
        component: () => import('@/views/exam/exam.vue'),
        meta: {
          title: '考试',
          hiddenNav: true
        }
      },
      {
        path: '/testResults',
        name: 'testResults',
        component: () => import('@/views/exam/testResults.vue'),
        meta: {
          title: '考试结果',
          hiddenNav: true
        }
      },
      {
        path: '/queryResults',
        name: 'queryResults',
        component: () => import('@/views/queryResults/index.vue'),
        meta: {
          title: '查询成绩'
        }
      },
      {
        path: '/certificate',
        name: 'certificate',
        component: () => import('@/views/certificate.vue'),
        meta: {
          title: '证书公示'
        }
      },
      {
        path: '/mycertificate',
        name: 'mycertificate',
        component: () => import('@/views/mycertificate.vue'),
        meta: {
          title: '我的证书'
        }
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/feedback.vue'),
        meta: {
          title: '平台反馈'
        }
      }
    ]
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/video.vue'),
    meta: {
      title: '视频'
    }
  },
  {
    path: '/hello',
    name: 'hello',
    component: () => import('@/views/hello.vue'),
    meta: {
      title: '招标代理'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
